(function () {
  'use strict';
  angular.module('ringbaPortal')
    .directive('draggable', function (Draggable) {
      'ngInject';

      const draggableOptions = [
        'draggable',
        'dropzone',
        'handle',
        'delay',
        'native',
        'plugins',
        'appendTo',
        'classes',
      ];
      // var draggableClasses = [
      //   'body:dragging',
      //   'container:dragging',
      //   'source:dragging',
      //   'source:placed',
      //   'container:placed',
      //   'draggable:over',
      //   'droppable:active',
      //   'droppable:occupied',
      //   'container:over',
      //   'mirror'
      // ];
      const draggableEvents = [
        'drag:start',
        'drag:move',
        'drag:over',
        'drag:over:container',
        'drag:out',
        'drag:out:container',
        'drag:stop',
        'drag:pressure',
        'droppable:dropped',
        'droppable:returned',
        'mirror:created',
        'mirror:destroy',
        'mirror:attached',
        'mirror:move'
      ];

      return {
        restrict: 'A',
        scope: {
          draggableOptions: '=draggableOptions'
        },
        link: function (scope, element) {

          const options = {};
          let droppable = null;

          for (const optionIndex in draggableOptions) {
            const currentOptionValue = draggableOptions[optionIndex];
            if (scope.draggableOptions[currentOptionValue] !== undefined) {
              options[currentOptionValue] = scope.draggableOptions[currentOptionValue];
            }
          }
          droppable = new Draggable.Droppable(element[0], options);

          for (const eventIndex in draggableEvents) {
            const currentEventValue = draggableEvents[eventIndex];
            if (typeof scope.draggableOptions.events[currentEventValue] === 'function') {
              droppable.on(currentEventValue, scope.draggableOptions.events[currentEventValue]);
            }
          }

          scope.$on('$destroy', function () {
            if (droppable) {
              droppable.destroy();
            }
          });
        }
      };
    });
})();
